<div class="d-flex align-items-center">
  @for(language of orderOfLanguages;track language){
  <div>
    <div [ngClass]="{'me-3': orderOfLanguages.indexOf(language) < (orderOfLanguages.length - 1)}">
      <i [class]="languageIcons[language]" [class.selected]="selectedLanguage === language"
        (click)="setLanguage($event, language)">
        <div class="checkmark-position-box">
          <app-checkmark-indicator [isChecked]="getIsFilledValue(language)" [showIsNotCheckedIndicator]="false" />
        </div>
        <div class="required-position-box" [class.selected]="selectedLanguage === language">
          @if(getIsRequiredValue(language) && selectedLanguage !== language){
          <span style="font-style: normal;">*</span>
          }
        </div>
      </i>
    </div>
  </div>
  }
</div>